import produce from 'immer';

import { OrganizationAccessRequest } from '../../types';
import { createReducer } from '../utils';

import * as OrganizationAccessRequestActions from './actions';

const initialState = {
  organizationAccessRequests: {},
};

export default createReducer(initialState, {
  [`${OrganizationAccessRequestActions.ORGANIZATION_ACCESS_REQUEST_INVITE_EXISTING}_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      const { id, fulfilled } = action.payload.data as OrganizationAccessRequest;
      const accessRequest = draftState.organizationAccessRequests[id];
      if (accessRequest) {
        accessRequest.fulfilled = fulfilled;
      }
    });
  },
  [`${OrganizationAccessRequestActions.ORGANIZATION_ACCESS_REQUEST_REMOVE_ACCESS_REQUEST}_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      const { accessRequestId } = action.meta;
      delete draftState.organizationAccessRequests[accessRequestId];
    });
  },
});
